import { useState, useEffect, useRef } from "react";
import useAlert from "../../../hooks/useAlert/index";
import ButtonAcaoGrande from "../../Botoes/ButtonAcaoGrande";
import CircularProgress from "@mui/material/CircularProgress";
import FlightIcon from "@mui/icons-material/Flight";
import Seletor from "../../Seletor";
import {
  Grid,
  Box,
  Typography,
  Hidden,
  Skeleton,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import { DatePicker } from "rsuite";
import SearchIcon from "@mui/icons-material/Search";
import { MenuDashboard, PaginasMenuDashboard, BreadCrumbsPaginas } from "../..";

import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import PassageiroList from "../../PassageiroList";

import Itens from "./Itens";

import { getVitrine, addItemVitrine } from "../../../api/Carrinho/SeguroViagem";
import { useAuth } from "../../../hooks/AuthContext";

import { Style } from "./styles";
import { useSeguro } from "../../../store/seguroViagem";

function VitrineSeguroViagem() {
  const { user } = useAuth();
  const classes = Style();
  const theme = useTheme();
  const [dadosSeguro, setDadosSeguro] = useState(null);
  const [isLoadingFields, setIsLoadingFields] = useState(true);
  const { showAlertError } = useAlert();
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [texto, setTexto] = useState("Buscar");
  const [isShowItens, setIsShowItens] = useState(false);
  const [destinos, setDestinos] = useState([]);
  const { infoSeguro, addInfoSeguro, updatePacotes } = useSeguro();

  // Refs para o scroll
  const itensRef = useRef(null);
  const topoRef = useRef(null);

  const [form, setForm] = useState({
    idDestino: 1,
    idCliente: user.id,
    idHotsite: user.idHotsite ?? 0,
    passageiros: [],
    dataIda: null,
    dataVolta: null,
    dataDe: null,
    dataAte: null,
  });

  const datePickerStyles = {
    width: "100%",
    display: "block",
    borderRadius: "7px",
    border: "0.5px solid #ccc",
    background: "#fafafa !important",
  };

  const breadCrumbs = [
    {
      label: "Seguro de viagem",
      icon: <CompareArrowsIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
    },
    {
      label: "Compra de seguro de viagem",
      icon: <DoubleArrowIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
    },
  ];

  const localeConfig = {
    sunday: "Dom",
    monday: "Seg",
    tuesday: "Ter",
    wednesday: "Qua",
    thursday: "Qui",
    friday: "Sex",
    saturday: "Sáb",
    ok: "OK",
    today: "Hoje",
    yesterday: "Ontem",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
  };

  const calcularDiasCobertura = () => {
    if (!form.dataIda || !form.dataVolta) return 0;

    const umDia = 24 * 60 * 60 * 1000; // milissegundos em um dia
    const dataInicio = new Date(form.dataIda);
    const dataFim = new Date(form.dataVolta);

    // Calcula a diferença em dias e adiciona 1 para incluir ambos os dias
    const diffDias = Math.round(Math.abs((dataFim - dataInicio) / umDia)) + 1;
    return diffDias;
  };

  const desativarDatasPassadas = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    // Desativa hoje e datas passadas
    return selectedDate.getTime() <= today.getTime();
  };

  const desativarDatasAntesIda = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Se não tem data de ida selecionada, desativa datas passadas
    if (!form.dataIda) {
      return date < today;
    }

    // Se tem data de ida, desativa datas anteriores à data de ida
    const dataIda = new Date(form.dataIda);
    dataIda.setHours(0, 0, 0, 0);
    return date < dataIda;
  };

  // Função para fazer scroll suave até os itens
  const scrollToItens = () => {
    if (itensRef.current) {
      setTimeout(() => {
        itensRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 300);
    }
  };

  // Função para voltar ao topo
  const scrollToTopo = () => {
    if (topoRef.current) {
      topoRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const init = async () => {
    try {
      const response = await getVitrine();

      if (!!response?.errorMessage) throw new Error(response.errorMessage);

      setDestinos(response.data.destinos);

      setForm((prevState) => ({
        ...prevState,
        idDestino: response.data.destinos[0].id,
        descricaoDestino: response.data.destinos[0].descricao,
      }));
    } catch (error) {
      showAlertError("Ops Algo deu errado: " + error.message);
    } finally {
      setTimeout(() => {
        setIsLoadingFields(false);
      }, 2000);
    }
  };

  useEffect(() => {
    init();
  }, []);

  // Efeito para scroll automático quando os itens são carregados
  useEffect(() => {
    if (isShowItens && infoSeguro.pacotes?.length > 0) {
      scrollToItens();
    }
  }, [isShowItens, infoSeguro.pacotes]);

  const handlerChangeDestino = (id, descricao) => {
    setForm({ ...form, idDestino: id, descricaoDestino: descricao });
  };

  const handlerChangeDataIda = (date) => {
    if (date) {
      const dataIda = new Date(date);
      const dataFormatada = `${dataIda.getFullYear()}-${
        dataIda.getMonth() + 1
      }-${dataIda.getDate()}`;

      setForm((prev) => ({
        ...prev,
        dataIda: date,
        dataDe: dataFormatada,
      }));

      // Se a data de volta for anterior à nova data de ida, limpa a data de volta
      if (form.dataVolta && date > form.dataVolta) {
        setForm((prev) => ({
          ...prev,
          dataVolta: null,
          dataAte: null,
        }));
      }
    } else {
      setForm((prev) => ({
        ...prev,
        dataIda: null,
        dataDe: null,
      }));
    }
  };

  const handlerChangeDataVolta = (date) => {
    if (date) {
      const dataVolta = new Date(date);
      const dataFormatada = `${dataVolta.getFullYear()}-${
        dataVolta.getMonth() + 1
      }-${dataVolta.getDate()}`;

      setForm((prev) => ({
        ...prev,
        dataVolta: date,
        dataAte: dataFormatada,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        dataVolta: null,
        dataAte: null,
      }));
    }
  };

  const handlerChangePassageiro = (p) => {
    setForm(() => ({ ...form, passageiros: p }));
  };

  const handlerSearch = async () => {
    setIsLoadingSearch(true);

    try {
      if (!form.dataDe || !form.dataAte) {
        throw new Error(
          "É necessário informar a data de ida e de volta da sua viagem. - RV5H9"
        );
      }

      if (form.passageiros.length <= 0) {
        throw new Error(
          "É necessário preencher a idade de pelo menos 1 passageiro. - RUT1X"
        );
      }

      addInfoSeguro(form);
      const response = await addItemVitrine(form);

      if (!!response?.errorMessage) throw new Error(response.errorMessage);

      addInfoSeguro(form);
      updatePacotes(response.data);

      setIsLoadingSearch(false);
      setIsShowItens(true);
      setDadosSeguro(response.data);
    } catch (error) {
      setIsLoadingSearch(false);
      showAlertError(`Ops, Algo deu errado: ${error.message}`);
      setTexto("Refazer busca");
    }
  };

  // Função para formatar a data para exibição
  const formatarDataExibicao = (data) => {
    if (!data) return null;
    return new Date(data).toLocaleDateString("pt-BR");
  };

  return (
    <>
      {/* Ref para o topo da página */}
      <div ref={topoRef} />

      <MenuDashboard pagina={PaginasMenuDashboard.SeguroViagem}>
        <Hidden smUp>
          <Box sx={{ pl: 2 }}>
            <BreadCrumbsPaginas list={breadCrumbs} />
          </Box>
        </Hidden>

        <Hidden smDown>
          <Box sx={{ pt: 2 }}>
            <BreadCrumbsPaginas list={breadCrumbs} />
          </Box>
        </Hidden>

        {isLoadingSearch && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              background: "rgba(255, 255, 255, 0.8)",
              width: "100%",
              height: "100%",
              zIndex: 2000,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress color="primary" size={80} thickness={4} />
            <FlightIcon color="primary" style={{ marginTop: 10 }} />
            <Typography variant="h6" color="primary" sx={{ mt: 2 }}>
              Buscando melhores seguros...
            </Typography>
          </Box>
        )}

        {isLoadingFields ? (
          <Grid container className={classes.container} justifyContent="center">
            <Grid item xs={12} md={8} lg={6}>
              <Card className={classes.borderLoading}>
                <CardContent>
                  <Skeleton height={80} width={"100%"} animation="wave" />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-around",
                      gap: "1rem",
                      mt: 2,
                    }}
                  >
                    <Skeleton height={80} width={"100%"} animation="wave" />
                    <Skeleton height={80} width={"100%"} animation="wave" />
                    <Skeleton height={80} width={"100%"} animation="wave" />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Grid container justifyContent="center" sx={{ mt: 3 }}>
            <Grid item xs={12} md={8} lg={6} xl={5}>
              <Card
                sx={{
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  overflow: "visible",
                  mb: 3,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  {/* Header mais compacto */}
                  <Box sx={{ textAlign: "center", mb: 3 }}>
                    <Typography
                      variant="h5"
                      color="primary"
                      sx={{
                        fontWeight: "bold",
                        mb: 0.5,
                      }}
                    >
                      Seguro Viagem
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Informe os dados da sua viagem
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    {/* Destino */}
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                          fontSize: "0.9rem",
                          color: theme.palette.text.primary,
                        }}
                        variant="subtitle2"
                      >
                        DESTINO
                      </Typography>
                      {destinos && (
                        <Seletor
                          setSelectIdDesc={handlerChangeDestino}
                          list={destinos}
                          size="small"
                          label="Escolha o destino"
                          variant="outlined"
                          fullWidth={true}
                          value={form.idDestino}
                        />
                      )}
                    </Grid>

                    {/* Datas - Agora separadas */}
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                          fontSize: "0.9rem",
                          color: theme.palette.text.primary,
                        }}
                        variant="subtitle2"
                      >
                        DATAS DA VIAGEM
                      </Typography>

                      {/* Preview das datas selecionadas */}
                      {(form.dataIda || form.dataVolta) && (
                        <Box
                          sx={{
                            mb: 2,
                            p: 1.5,
                            bgcolor: "success.light",
                            borderRadius: 1,
                            border: "1px solid",
                            borderColor: "success.main",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="white"
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            🗓️{" "}
                            {form.dataIda
                              ? formatarDataExibicao(form.dataIda)
                              : "___"}
                            {" → "}
                            {form.dataVolta
                              ? formatarDataExibicao(form.dataVolta)
                              : "___"}
                          </Typography>
                        </Box>
                      )}

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              mb: 1,
                              fontSize: "0.8rem",
                              color: theme.palette.text.secondary,
                            }}
                          >
                            DATA DE IDA
                          </Typography>
                          <DatePicker
                            size="md"
                            placeholder="Selecione a ida"
                            value={form.dataIda}
                            onChange={handlerChangeDataIda}
                            shouldDisableDate={desativarDatasPassadas}
                            style={datePickerStyles}
                            oneTap
                            locale={localeConfig}
                            format="dd/MM/yyyy"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              mb: 1,
                              fontSize: "0.8rem",
                              color: theme.palette.text.secondary,
                            }}
                          >
                            DATA DE VOLTA
                          </Typography>
                          <DatePicker
                            size="md"
                            placeholder="Selecione a volta"
                            value={form.dataVolta}
                            onChange={handlerChangeDataVolta}
                            disabledDate={desativarDatasAntesIda}
                            style={{
                              ...datePickerStyles,
                              borderColor: !form.dataIda
                                ? "#ccc"
                                : datePickerStyles.border,
                            }}
                            oneTap
                            locale={localeConfig}
                            format="dd/MM/yyyy"
                            disabled={!form.dataIda}
                          />
                          {!form.dataIda && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ mt: 0.5, display: "block" }}
                            >
                              Selecione primeiro a data de ida
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                      {form.dataIda && form.dataVolta && (
                        <Box
                          sx={{
                            mt: 2,
                            p: 1.5,
                            bgcolor: "primary.light",
                            borderRadius: 1,
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="white"
                            sx={{ fontWeight: "bold" }}
                          >
                            🛡️ Cotação cobrindo {calcularDiasCobertura()}{" "}
                            {calcularDiasCobertura() === 1 ? "dia" : "dias"} de
                            viagem
                          </Typography>
                        </Box>
                      )}
                    </Grid>

                    {/* Passageiros */}
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                          fontSize: "0.9rem",
                          color: theme.palette.text.primary,
                        }}
                        variant="subtitle2"
                      >
                        PASSAGEIROS
                      </Typography>
                      <PassageiroList
                        onChange={handlerChangePassageiro}
                        compact={true} // ← Isso ativa a nova versão
                      />
                    </Grid>

                    {/* Botão Buscar */}
                    <Grid item xs={12} sx={{ mt: 1 }}>
                      <ButtonAcaoGrande
                        sx={{
                          height: 44,
                          width: "100%",
                          borderRadius: 1,
                          fontSize: "1rem",
                          fontWeight: "bold",
                        }}
                        Handle={handlerSearch}
                        texto={texto}
                        loading={isLoadingSearch}
                      >
                        <SearchIcon sx={{ mr: 1 }} fontSize="small" />
                      </ButtonAcaoGrande>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}

        {/* Área dos Itens */}
        {isShowItens && infoSeguro.pacotes?.length > 0 && (
          <>
            <div ref={itensRef} />
            <Grid container justifyContent="center">
              <Grid item xs={12} lg={10}>
                <Itens diasViagem={calcularDiasCobertura()} />
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                  <ButtonAcaoGrande
                    sx={{
                      borderRadius: 1,
                      px: 2,
                      py: 1,
                      fontSize: "0.8rem",
                    }}
                    variant="contained"
                    Handle={scrollToTopo}
                    texto="Voltar ao Topo"
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </MenuDashboard>
    </>
  );
}

export default VitrineSeguroViagem;
